import { Pipe, PipeTransform } from '@angular/core';
import { AttendingStatus } from '../models/AttendingStatus.enum';

@Pipe({
  name: 'attendingIcon',
})
export class attendingIconPipe implements PipeTransform {
  transform(value: unknown, arg?: 'key' | 'value' | unknown): unknown {
    let enumValue;
    if (arg === "key") {
      enumValue = AttendingStatus.retrieveValueByKey(value as string);
    } else {
      enumValue = value as string;
    }
    return AttendingStatus.retrieveIconByValue(enumValue);
  }
}
